import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('a-form-model', {
    ref: "formModelRef",
    attrs: {
      "model": _vm.formData,
      "data-sign": "my_account_add_or_edit_refund_form",
      "rules": _vm.formDataRules,
      "layout": "horizontal",
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 20
      }
    }
  }, [_vm.type === _vm.$enum.common.ModalTypeEnum.EDIT ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u9000\u6B3E\u5355\u53F7"),
      "label": _vm.t('退款单号')
    }
  }, [_vm._v(" " + _vm._s(_vm.data.order_number) + " ")]) : _vm._e(), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u9000\u6B3E\u4E3B\u4F53"),
      "label": _vm.t('退款主体'),
      "prop": "account_code"
    }
  }, [_c('a-select', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择')
    },
    on: {
      "change": _vm.handleAccountCodeChange
    },
    model: {
      value: _vm.formData.account_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "account_code", $$v);
      },
      expression: "formData.account_code"
    }
  }, _vm._l(_vm.accountList, function (item) {
    return _c('a-select-option', {
      key: item.account_code,
      attrs: {
        "value": item.account_code
      }
    }, [item.sign_body_status === _vm.$enum.mine.SignBodyStatusEnum.DISABLED ? _c('span', {
      staticClass: "fr ml-15 stop-span",
      attrs: {
        "type": "meh"
      }
    }, [_c('a-icon', {
      attrs: {
        "type": "exclamation-circle",
        "theme": "filled"
      }
    }), _vm._v(" " + _vm._s(_vm.t('已停用')) + " ")], 1) : _vm._e(), _vm._v(" " + _vm._s(item.account_code) + " " + _vm._s(item.sign_body_name) + " " + _vm._s(item.sign_business_list_text) + " ")]);
  }), 1)], 1), _c('div', {
    staticClass: "mb-10 flex-box"
  }, [_c('a-col', {
    attrs: {
      "span": 4
    }
  }), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.summaryLoading
    }
  }, [_vm.summaryList.length > 0 ? _c('a-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between",
      "gutter": [14, 14]
    }
  }, _vm._l(_vm.summaryList, function (item, index) {
    return _c('a-col', {
      key: index,
      attrs: {
        "span": 8
      }
    }, [_c('a-card', {
      class: item.amount === '0' ? 'amount-zero' : '',
      attrs: {
        "bordered": false
      }
    }, [_c('a-card-grid', {
      staticClass: "account_list",
      class: item.amount === '0' ? 'disabled' : ''
    }, [_c('div', [_c('span', [_vm._v(_vm._s(item.currency_code_text))]), _c('span', [_vm._v(_vm._s(item.currency_code))])]), _c('div', [_c('span', [_vm._v(_vm._s(_vm.t('账户余额')))]), _c('span', {
      staticClass: "money"
    }, [_c('money-format', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "num": item.balance,
        "formatter": true
      }
    })], 1)])])], 1)], 1);
  }), 1) : _vm._e()], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u9000\u6B3E\u7C7B\u578B"),
      "label": _vm.t('退款类型'),
      "prop": "refund_type"
    }
  }, [_c('a-select', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择')
    },
    model: {
      value: _vm.formData.refund_type,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "refund_type", $$v);
      },
      expression: "formData.refund_type"
    }
  }, _vm._l(_vm.showRefundTypeEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _vm.formData.refund_type === _vm.$enum.finance.RefundTypeEnum.WRONG_PAYMENT || _vm.formData.refund_type === _vm.$enum.finance.RefundTypeEnum.DEPOSIT_REFUNDS ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5BA2\u6237\u94F6\u884C\u56DE\u5355"),
      "prop": "proof"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.t('客户银行回单')) + " "), _c('a-popover', {
    attrs: {
      "content": _vm.uploadTipMessage
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "question-circle"
    }
  })], 1)], 1), _c('single-upload', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "api": "finance.uploadBalanceReturnAttachment",
      "validate-type": "BalanceReturnAttachmentRule",
      "upload-success": _vm.handleUploadSuccess
    },
    on: {
      "onTipMessage": _vm.handleUploadFileTipMessage
    },
    model: {
      value: _vm.formData.proof,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "proof", $$v);
      },
      expression: "formData.proof"
    }
  }), _vm.previewProof && _vm.type === _vm.$enum.common.ModalTypeEnum.EDIT ? _c('a', {
    staticClass: "ml-5",
    attrs: {
      "target": "_blank",
      "href": _vm.previewProof,
      "fbu-analyse-name": $t("\u4E0B\u8F7D")
    }
  }, [_c('a-icon', {
    staticClass: "ml-5",
    attrs: {
      "type": "download"
    }
  }), _vm._v(_vm._s(_vm.t('下载')) + " ")], 1) : _vm._e()], 1) : _vm._e(), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u9000\u6B3E\u4E8B\u7531"),
      "label": _vm.t('退款事由'),
      "prop": "refund_remark"
    }
  }, [_c('my-textarea', {
    attrs: {
      "rows": 4,
      "placeholder": _vm.t('请输入退款事由'),
      "max-length": 200
    },
    model: {
      value: _vm.formData.refund_remark,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "refund_remark", $$v);
      },
      expression: "formData.refund_remark"
    }
  })], 1), _c('a-form-model-item', {
    staticClass: "receive-account-item",
    attrs: {
      "fbu-analyse-name": $t("\u8BF7\u9009\u62E9\u6536\u6B3E\u8D26\u53F7"),
      "prop": "receive_bank_account"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.t('请选择收款账号')) + " "), _c('a-popover', {
    attrs: {
      "content": _vm.t('只可选择付款账户状态是「可用」且银行是非第三方平台的账户')
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "question-circle"
    }
  })], 1)], 1), _c('my-table', {
    attrs: {
      "bordered": "",
      "data-sign": "pay_account_refund_list_table",
      "size": "middle",
      "pagination": false,
      "row-key": "pay_account",
      "columns": _vm.receiveAccountColumns,
      "data-source": _vm.payAccountList,
      "scroll": {
        x: 'max-content'
      },
      "row-selection": {
        type: 'radio',
        selectedRowKeys: _vm.selectedReceiveAccountKeys,
        onChange: _vm.handleReceiveAccountSelect
      }
    },
    scopedSlots: _vm._u([{
      key: "open_bank_name",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._v(_vm._s(_vm._f("filterEmpty")(record.open_bank_name)))];
      }
    }, {
      key: "pay_account",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._v(_vm._s(_vm._f("filterEmpty")(record.pay_account)))];
      }
    }, {
      key: "currency_codes",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._v(_vm._s(_vm._f("filterEmpty")(record.currency_codes && record.currency_codes.join(', '))))];
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return [_c('a', {
          attrs: {
            "href": "javascript:;",
            "fbu-analyse-name": $t("\u7F16\u8F91")
          },
          on: {
            "click": function ($event) {
              return _vm.handleEditPayAccount(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('编辑')))])];
      }
    }])
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u7533\u8BF7\u9000\u6B3E\u91D1\u989D"),
      "required": "",
      "label": _vm.t('申请退款金额')
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label-col": {
        span: 0
      },
      "prop": "currency_code"
    }
  }, [_c('my-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "allow-clear": false,
      "placeholder": _vm.t('请选择币种')
    },
    on: {
      "change": _vm.handleCurrencyChange
    },
    model: {
      value: _vm.formData.currency_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "currency_code", $$v);
      },
      expression: "formData.currency_code"
    }
  }, _vm._l(_vm.currencyCodeList, function (item) {
    return _c('a-select-option', {
      key: item.currency_code,
      attrs: {
        "value": item.currency_code
      }
    }, [_vm._v(_vm._s(item.currency_code) + " (" + _vm._s(item.currency_name) + ")")]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": {
        span: 0
      },
      "prop": "amount"
    }
  }, [_c('a-input-number', _vm._b({
    ref: "refAmount",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.isSmallCurrency(_vm.formData.currency_code) ? _vm.t('仅支持整数') : '',
      "step": 1
    },
    model: {
      value: _vm.formData.amount,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "amount", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.amount"
    }
  }, 'a-input-number', _vm.isSmallCurrency(_vm.formData.currency_code) ? {
    precision: 0
  } : {}, false))], 1)], 1)], 1), _c('a-form-model-item', {
    staticClass: "agree",
    attrs: {
      "label": "",
      "wrapper-col": {
        offset: 4
      }
    }
  }, [_c('a-checkbox', {
    attrs: {
      "data-permission": "finance_refund_form_protocol",
      "id": "finance_refund_form_protocol"
    },
    model: {
      value: _vm.agree,
      callback: function ($$v) {
        _vm.agree = $$v;
      },
      expression: "agree"
    }
  }, [_c('span', {
    staticClass: "refund-notice"
  }, [_vm._v(" " + _vm._s(_vm.t('我已阅读并同意')) + " "), _c('a', {
    attrs: {
      "href": "#",
      "fbu-analyse-name": $t("\u300A\u514D\u8D23\u58F0\u660E\u300B")
    },
    on: {
      "click": _vm.handleNotice
    }
  }, [_vm._v(_vm._s(_vm.t('《免责声明》')))])])]), _c('a-form-model-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isErrorTip && !_vm.agree,
      expression: "isErrorTip && !agree"
    }],
    staticClass: "error-tip"
  }, [_vm._v(_vm._s(_vm.t('请勾选"我已阅读并同意《免责声明》"')) + " ")])], 1), _c('pay-account-add-or-edit', {
    ref: "payAccountEditRef",
    attrs: {
      "pay-id": _vm.editPayAccountId,
      "edit-disabled": true,
      "bank-list": _vm.bankList,
      "account-list": _vm.rechargeAccountList
    },
    on: {
      "success": _vm.handlePayAccountEditSuccess
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };